/**
 * Hero Video Handler
 * Manages autoplay with poster fallback
 * Minimal, efficient implementation
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideos);
  } else {
    initHeroVideos();
  }

  function initHeroVideos() {
    const heroSections = document.querySelectorAll('.hero-video');
    
    heroSections.forEach(section => {
      const video = section.querySelector('.hero-video__video');
      const poster = section.querySelector('.hero-video__poster');
      
      if (!video) return;

      // Set up video
      setupVideo(video, poster);

      // Handle visibility change (pause when tab is hidden)
      handleVisibilityChange(video);
    });
  }

  function setupVideo(video, poster) {
    // Ensure video is muted and has correct attributes
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Try to play
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Autoplay started successfully
          console.log('Hero video autoplay started');
          if (poster) {
            poster.classList.remove('visible');
            poster.setAttribute('aria-hidden', 'true');
          }
        })
        .catch(error => {
          // Autoplay was prevented
          console.log('Hero video autoplay prevented, showing poster');
          if (poster) {
            poster.classList.add('visible');
            poster.removeAttribute('aria-hidden');
          }
        });
    }

    // Retry play on user interaction if it failed
    if (poster && poster.classList.contains('visible')) {
      const retryPlay = () => {
        video.play()
          .then(() => {
            poster.classList.remove('visible');
            poster.setAttribute('aria-hidden', 'true');
          })
          .catch(() => {
            // Still can't play, that's okay
          });
        
        // Remove listeners after first interaction
        document.removeEventListener('click', retryPlay);
        document.removeEventListener('scroll', retryPlay);
      };

      document.addEventListener('click', retryPlay, { once: true });
      document.addEventListener('scroll', retryPlay, { once: true, passive: true });
    }

    // Handle video load errors
    video.addEventListener('error', (e) => {
      console.error('Hero video load error:', e);
      if (poster) {
        poster.classList.add('visible');
        poster.removeAttribute('aria-hidden');
      }
    });

    // Ensure loop continues (some browsers need this)
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      video.play().catch(() => {
        // Couldn't restart, show poster
        if (poster) {
          poster.classList.add('visible');
        }
      });
    });
  }

  function handleVisibilityChange(video) {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        video.pause();
      } else {
        video.play().catch(() => {
          // Couldn't play on return to tab
        });
      }
    });
  }

  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initHeroVideos();
    });

    document.addEventListener('shopify:section:unload', () => {
      // Clean up if needed
      const videos = document.querySelectorAll('.hero-video__video');
      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  // Export for potential external use
  window.HeroVideo = {
    init: initHeroVideos
  };
})();

